export class Counter {
    constructor(wrapper, navigation) {

        this.navigation = navigation;
        if(!navigation.active) {
            return;
        }
        this.max = navigation.slides.length;
        this.current = 1;

        this.counter = document.createElement('div');
        this.counter.classList.add('gallery__counter');
        wrapper.appendChild(this.counter);

        this.updateContent();
    }

    setCurrentSlide(value) {
        this.current = value + 1;
        this.updateContent();
    }

    updateContent() {
        if(this.counter) {
            this.counter.innerHTML = `${this.current} / ${this.max}`;
        }
    }
}
